import { css } from '@emotion/css';
import { Color } from 'src/styles';

export const editIcon = css`
  color: ${Color.BRAND.BRAND6};
  width: 32px;
  heght: 32px;
  font-size: 32px;
`;
